import React from 'react';
import { Box, Typography, CircularProgress, Chip, Button, Tooltip } from '@mui/material';
import { CloudDone, CloudOff, Refresh } from '@mui/icons-material';
import { useDevices } from '../../contexts/DevicesContext';

const ConnectionStatus: React.FC = () => {
  const { connectionStatus, fetchDevices } = useDevices();
  
  const handleRefresh = () => {
    fetchDevices();
  };
  
  // Return different UI based on connection status
  if (connectionStatus === 'connected') {
    return (
      <Tooltip title="Connected to server">
        <Chip 
          icon={<CloudDone fontSize="small" />} 
          label="Connected" 
          color="success"
          size="small"
          sx={{ ml: 1 }}
        />
      </Tooltip>
    );
  }
  
  if (connectionStatus === 'connecting') {
    return (
      <Tooltip title="Connecting to server...">
        <Chip
          icon={<CircularProgress size={12} color="inherit" />}
          label="Connecting..."
          color="info"
          size="small"
          sx={{ ml: 1 }}
        />
      </Tooltip>
    );
  }
  
  // Error state
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title="Connection error - click to retry">
        <Chip
          icon={<CloudOff fontSize="small" />}
          label="Connection Error"
          color="error"
          size="small"
          sx={{ ml: 1 }}
          onClick={handleRefresh}
        />
      </Tooltip>
      <Button 
        startIcon={<Refresh />} 
        size="small" 
        color="primary" 
        onClick={handleRefresh}
        sx={{ ml: 1, minWidth: 'auto' }}
      >
        Retry
      </Button>
    </Box>
  );
};

export default ConnectionStatus; 